import React, { useState, useEffect, useRef } from "react";
import { useHookstate } from "@hookstate/core";
import globalAuthStateStore from "../../../../../stores/globalAuthStateStore";
import { VirtualLibrarianService } from "../../../../../services/VirtualLibrarianService";
import { ButtonControl } from "../../../../../components/controls/ButtonControl";
import "./chatLandingPage.scss";

export default function ChatLandingPage() {
  const [suggestedQuestions, setSuggestedQuestions] = useState([]);
  const [typedQuestion, setTypedQuestion] = useState("");

  const authStore = useHookstate(globalAuthStateStore);
  const vlService = React.useMemo(
    () => new VirtualLibrarianService(authStore),
    [authStore]
  );

  const handleQuestion = (question) => {
    sessionStorage.setItem("virtualLibrarianVideoQuestion", question);
    window.dispatchEvent(new Event("virtualLibrarianQuestionSubmittedUpdated"));
    sessionStorage.setItem("virtualLibrarianLandingInvisible", true);
    window.dispatchEvent(new Event("virtualLibrarianLandingInvisible"));
  };

  const handlePrevQuestion = (question) => {
    sessionStorage.setItem("previousQuestionSubmitted", question);
    sessionStorage.setItem("virtualLibrarianLandingInvisible", true);
    window.dispatchEvent(new Event("virtualLibrarianLandingInvisible"));
  };

  const defaultSuggestedQuestions = [
    "What are the components of a post-conference?",
    "I need video content demonstrating a 6th grade math classroom lesson.",
    "What makes for a great lesson observation?",
    "Show me video content with examples of academic feedback.",
    "Give me step by step instructions for how to coach a new teacher.",
    "How do I improve student assessment scores?",
    "Can you summarize the 5 steps for effective learning?"
  ];

  const fetchSuggestedQuestions = async () => {
    try {
      const result = await vlService.getChatLogsById();

      if (result && result.Success && result.Data) {
        const questions = [];

        const logsArray = Array.isArray(result.Data)
          ? result.Data
          : [result.Data];

        for (const log of logsArray) {
          if (log.Question && typeof log.Question === "string") {
            let documentCount = 0;
            let videoCount = 0;

            if (log.Citations) {
              try {
                const citationsData =
                  typeof log.Citations === "string"
                    ? JSON.parse(log.Citations)
                    : log.Citations;

                if (citationsData && Array.isArray(citationsData)) {
                  const documentIds = new Set();
                  const videoIds = new Set();

                  citationsData.forEach((citation) => {
                    const docType = citation.type || citation.Type;
                    const contentId =
                      citation.content_id || citation.ContentId || "";

                    if (contentId) {
                      if (docType === "video_section") {
                        videoIds.add(contentId);
                      } else {
                        documentIds.add(contentId);
                      }
                    }
                  });

                  documentCount = documentIds.size;
                  videoCount = videoIds.size;
                }
              } catch (e) {
                console.error("Error parsing citations for question:", e);
              }
            }

            questions.push({
              text: log.Question,
              timestamp: log.CreatedOn || new Date().toISOString(),
              documentCount: documentCount,
              videoCount: videoCount,
            });
          }
        }

        // Sort by timestamp (most recent first)
        questions.sort((a, b) => new Date(b.timestamp) - new Date(a.timestamp));

        if (questions.length > 0) {
          setSuggestedQuestions(questions);
        } else {
          setSuggestedQuestions([]);
        }
      } else {
        setSuggestedQuestions([]);
      }
    } catch (error) {
      setSuggestedQuestions([]);
    }
  };

  useEffect(() => {
    fetchSuggestedQuestions();
  }, []);

  const handleOnKeyDown = (e) => {
    if (e.key === "Enter") {
      e.preventDefault();
      handleQuestion(typedQuestion);
    }
  };

  return (
    <div className="chat-landing-content">
      <div className="chat-landing-input-container">
        <h3>Search</h3>
        <div className="chat-landing-input">
          <input
            value={typedQuestion}
            onChange={(e) => setTypedQuestion(e.target.value)}
            placeholder="Enhanced Search throughout this site and all connected videos, articles, and books"
            onKeyDown={handleOnKeyDown}
            maxLength={10000}
            className="vl-chat-input-component"
          />
          <ButtonControl
            type={"okay"}
            onClick={() => handleQuestion(typedQuestion)}
          >
            SUBMIT
          </ButtonControl>
        </div>
      </div>
      <div className="question-box">
      <div className="recent-questions">
        <h3>Some Recent Questions</h3>
        <div className="questions-list">
          {suggestedQuestions?.slice(0, 3).map((question, index) => (
            <div
              className="question-item"
              key={index}
              onClick={() =>
                handlePrevQuestion(
                  typeof question === "string" ? question : question.text
                )
              }
            >
              {typeof question === "string" ? question : question.text}
            </div>
          ))}
        </div>
      </div>
      <br></br>
      <div className="recent-questions">
        <h3>Some Popular Questions</h3>
        <div className="questions-list">
          {[...defaultSuggestedQuestions]?.sort(() => 0.5 - Math.random()).slice(0, 7).map((question, index) => (
            <div
              className="question-item"
              key={index}
              onClick={() =>
                handleQuestion(
                  typeof question === "string" ? question : question.text
                )
              }
            >
              {typeof question === "string" ? question : question.text}
            </div>
          ))}
        </div>
      </div>
    </div>
    </div>
  );
}
